import { Helmet } from 'react-helmet-async';
import MainStyles from './MainStyles';

export default function MainHead() {
  return (
    <>
      <Helmet>
        <title>Aircabi -Airport Transfers Made Effortless</title>
        <meta name="description" content="Aircabi - Airport Transfers Made Effortless" />
      </Helmet>
      <MainStyles />
    </>
  );
}
